import React from 'react';
import { Link } from 'react-router-dom';
import { getArcticCoachUrl } from '../constants/config';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950/80 text-slate-400 py-16 mt-12 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-white text-xl font-bold mb-6">Lapland <span className="aurora-text">AI Lab</span></h3>
            <p className="text-sm leading-relaxed max-w-sm mb-6">
              Edistämme vastuullista tekoälyä ja digitaalista turvallisuutta pohjoisella otteella. 
              Tämä opas on osa Labin koulutusmateriaaleja.
            </p>
            <div className="p-4 arctic-panel border border-white/10 rounded-xl text-[10px] leading-relaxed uppercase tracking-widest text-slate-500">
              <span className="text-amber-500 font-bold">Disclaimer:</span> Tämä materiaali on tarkoitettu yleiseen koulutuskäyttöön. Se ei korvaa ammattimaista tietoturvakonsultointia tai lakineuvontaa. Lab ei vastaa materiaalin soveltamisesta aiheutuvista vahingoista.
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-6">Navigaatio</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/content/kyber-perusteet" className="hover:text-teal-300 transition-colors">Kyberperusteet</Link></li>
              <li><Link to="/content/ai-safety" className="hover:text-teal-300 transition-colors">AI-turvallisuus</Link></li>
              <li><Link to="/content/mobiiliturva" className="hover:text-teal-300 transition-colors">Mobiiliturva</Link></li>
              <li><Link to="/business-audit" className="hover:text-teal-300 transition-colors">Pika-auditointi</Link></li>
              {/* Arctic Coach Footer Link */}
              <li>
                <a 
                  href={getArcticCoachUrl('footer')} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-purple-300 hover:text-purple-200 transition-colors font-bold"
                >
                  Arctic Coach (GPT)
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-6">Resurssit</h4>
            <p className="text-sm">
              Päivitetty helmikuussa 2026.<br />
              Versio 1.5 (Sprint 3 Enterprise)<br />
              Ei kolmannen osapuolen seurantaa.
            </p>
          </div>
        </div>
        <div className="border-t border-slate-900 mt-12 pt-8 text-xs text-center">
          &copy; 2026 Lapland AI Lab. Kaikki oikeudet pidätetään.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
